// Utility function to normalize strings: trims spaces, converts to lowercase, and removes accents
export function normalizeString(str: string): string {
  return str
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}
